import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
import { Reveal } from './Reveal';
const faqs = [{
  q: '¿Necesito experiencia previa?',
  a: 'No, el curso arranca desde cero. No hace falta ningún conocimiento previo.'
}, {
  q: '¿Cuánto tiempo lleva?',
  a: 'Podés avanzar a tu ritmo, sin límite de tiempo. Vos manejás tus horarios.'
}, {
  q: '¿Funciona desde el celular?',
  a: 'Sí, podés acceder desde cualquier dispositivo: celular, tablet o PC.'
}, {
  q: '¿Cuánto tiempo tengo acceso?',
  a: 'Acceso de por vida, con todas las actualizaciones futuras incluidas.'
}, {
  q: '¿Puedo pagar en cuotas?',
  a: 'Sí, hay opciones de pago en cuotas para que te resulte más cómodo.'
}, {
  q: '¿Hay garantía?',
  a: 'Sí, contás con una garantía de satisfacción de 7 días, sin preguntas.'
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-white py-24" data-id="element-27" data-mp="phoaxvbptsno">
      <div className="mx-auto max-w-3xl px-6" data-id="element-28" data-mp="pfv003u2km9v">
        <Reveal data-id="element-29" data-mp="uhaok5vghax0">
          <h2 className="font-display text-center text-3xl font-semibold text-[#2f2a33] sm:text-4xl" data-id="element-30" data-mp="ufpusigytw07">
            Preguntas frecuentes
          </h2>
        </Reveal>

        <div className="mt-12 space-y-3" data-id="element-31" data-mp="kibnp9gxmjkk">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <Reveal key={i} delay={i * 0.04} data-id="element-32" data-mp="6pvhy0wnc7fy" data-mpi={i}>
                <div className="overflow-hidden rounded-2xl border border-[#a78bdb]/20 bg-[#faf7fe]" data-id="element-33" data-mp="bhwpxams7c06">
                  <button onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left" data-id="element-34" data-mp="3sywqu9mvuifr">
                    <span className="font-medium text-[#2f2a33]" data-id="element-35" data-mp="3jyi02ur5gb4v">{f.q}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-[#a78bdb] transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-36" data-mp="3nyiggkxt6wek" />
                  </button>
                  <AnimatePresence initial={false} data-id="element-37" data-mp="1kr1b2vcb9wmb">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.28,
                  ease: 'easeInOut'
                }} data-id="element-38" data-mp="1koyjw7zf9xg0">
                        <p className="px-6 pb-5 text-[#2f2a33]/70" data-id="element-39" data-mp="23hj0apxxqa2x">{f.a}</p>
                      </motion.div>}
                  </AnimatePresence>
                </div>
              </Reveal>;
        })}
        </div>
      </div>
    </section>;
}